import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import moment from "moment";

import { dateWithDayOfWeek } from "../../utils/date";
import { TIME } from "../../utils/dateFormats";


const Item = ({ request, onShow }) => {
  const subFullName = (request) => {
    if(request.sub_full_name)
      return request.sub_full_name;

    if(request.processed && request.approved === null)
      return 'N/A'
    else
      return 'EMPLOYEE NOT FOUND'
  }

  return (
    <tr>
      <td
        className={classNames(
          "visible-xs",
          request.approved ? "success" : request.approved === false ? "danger" : "warning"
        )}
      />
      <td className="hidden-xs">{request.locationName}</td>
      <td className="hidden-xs">{request.positionName}</td>
      <td>
        {dateWithDayOfWeek(request.shift.start_time, true)} -{" "}
        {moment(request.shift.end_time).format(TIME)}
      </td>
      <td className="hidden-xs">
        {request.user_id && request.user ? (
          <span>
            {[request.user.first_name, request.user.last_name].join(", ")}
          </span>
        ) : (
          "EMPLOYEE NOT FOUND"
        )}
      </td>
      <td>
        {subFullName(request)}
      </td>
      <td
        className={classNames(
          "hidden-xs",
          request.approved ? "success" : request.approved === false ? "danger" : "warning"
        )}
      >
        {request.approved ? "Approved" : request.approved === false ? "Denied" : "Expired"}
      </td>
      <td className="hidden-xs">
        {request.processed_by_user_id ? (
          [request.processed_by_last_name, request.processed_by_first_name].join(", ")
        ) : (
          'DigiQuatics System'
        )}
      </td>
      <td>
        <a
          href="#"
          className="btn btn-text"
          onClick={() => {
            onShow(request);
          }}
        >
          VIEW
        </a>
      </td>
    </tr>
  );
}

const ListProcessed = ({ data, onShow }) => (
  <table className="table table-clean table-white shadowDepth1">
    <thead>
      <tr>
        <th className="visible-xs" />
        <th className="hidden-xs">Location</th>
        <th className="hidden-xs">Position</th>
        <th>Shift</th>
        <th className="hidden-xs">Requested By</th>
        <th>Sub Name</th>
        <th className="hidden-xs">Status</th>
        <th className="hidden-xs">Processed By</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {data.map((request, index) => (
        <Item key={index} request={request} onShow={onShow} />
      ))}
    </tbody>
  </table>
);

Item.propTypes = {
  request: PropTypes.object,
  onShow: PropTypes.func
};

ListProcessed.propTypes = {
  data: PropTypes.array,
  onShow: PropTypes.func
};

export default ListProcessed;
